<template>
<div>
  <footer>
    <div class="lg items">
      <b-link href="https://prd-inc.jp/" target="_blank">会社概要</b-link>
      <b-link href="http://guide.smartthon.com" target="_blank">よくある質問</b-link>
    </div>
    <div class="lg logo">
      <img src="../../assets/images/prd-logo.svg">
    </div>
     <div class="lg">
      Copyright © 2019 prd, Inc. All rights reserved.
     </div>
  </footer>
</div>
</template>
<script>
export default {
  name: 'shared-footer'
}
</script>
<style scoped>
footer {
  height: 100px;
  background-color: #ffffff;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  /* 縦方向中央揃え（Safari用） */
  align-items: center;
  /* 縦方向中央揃え */
  -webkit-justify-content: center;
  /* 横方向中央揃え（Safari用） */
  justify-content: space-between;
}

footer .lg {
  width: 320px;
  font-size: 14px;
}

footer .logo {
  height: 40px;
}

footer .logo img {
  height: 100%;
}

footer .items {
  text-align: left;
  padding-left: 10px;
}

footer .items a {
  margin-left: 20px;
  color: #1E4573;
}

@media (max-width: 480px) {
  footer {
    flex-direction: column;
    height: 100%;
    padding-bottom: 20px;
    position: relative;
  }
  footer .lg {
    margin-bottom: 10px;
  }
  footer .items {
    text-align: center;
    flex-direction: column;
    display: flex;
    padding-left: 0;
  }
  footer .items a {
    padding-top: 10px;
    margin-left: 0;
  }
  footer .logo {
    margin: 10px 0 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/share/footer.vue